import type { AdminSubscriptionItem } from "@/types/subscription";
import type { SubscriptionAction } from "./subscription-columns";
import { SubscriptionCard } from "./subscription-card";

interface SubscriptionCardListProps {
  data: AdminSubscriptionItem[];
  onAction: (subscription: AdminSubscriptionItem, action: SubscriptionAction) => void;
}

export function SubscriptionCardList({
  data,
  onAction,
}: SubscriptionCardListProps) {
  return (
    <div className="space-y-3">
      {data.map((subscription) => (
        <SubscriptionCard
          key={subscription.subscriptionId}
          subscription={subscription}
          onAction={onAction}
        />
      ))}
    </div>
  );
}
